import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Social from '../section-components/social';
import { useEffect } from 'react';
const NavbarV3 = () => {
  const publicUrl = process.env.PUBLIC_URL + '/';
  const location = useLocation();

  // On récupère la route courante
  const pathname = location.pathname;

  // Menu dynamique selon la route
  let menuLinks = [];

  // Page d'accueil : uniquement Qui sommes-nous & Nos projets + les liens généraux
  if (pathname === '/' || pathname === '/index' || pathname === '/index.js') {
    menuLinks = [
      { label: "Qui sommes-nous?", href: "#quisommesnous" },
      { label: "Nos projets", href: "#projet" },
	  
    ];
  }

  // Page Diamantine : apropos, services, plans, commodites + les liens généraux
  else if (pathname === '/Diamantine') {
    menuLinks = [
      { label: "À propos", href: "#apropos" },
      { label: "Nos services", href: "#services" },
      { label: "Nos plans", href: "#plans" },
      { label: "Nos commodités", href: "#commodites" },
	  { label: "Gallerie", href: "#gallerie" },
    ];
  }

  // Liens qui s'affichent partout (gallerie + contactez-nous)
  const generalLinks = [
    
    { label: "Contactez-nous", href: "#contact" },
  ];

  // Assemble le menu final
  const allLinks = [...menuLinks, ...generalLinks];

    useEffect(() => {
    const publicUrl = process.env.PUBLIC_URL + '/';

    // Charger main.js uniquement pour ce composant
    const script = document.createElement('script');
    script.src = `${publicUrl}assets/js/main.js`;
    script.async = true;
    document.body.appendChild(script);

    console.log('📸 main.js chargé pour Gallery');

    // Nettoyage quand le composant est démonté
    return () => {
      document.body.removeChild(script);
      console.log('🧹 main.js retiré après avoir quitté Gallery');
    };
  }, []); 
  return (
    <div>
      <header className="ltn__header-area ltn__header-5 ltn__header-logo-and-mobile-menu-in-mobile ltn__header-logo-and-mobile-menu ltn__header-transparent gradient-color-2">
        {/* ltn__header-top-area start */}
        <div
          style={{ display: "none" }}
          className="ltn__header-top-area section-bg-6 top-area-color-white---"
        >
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <div className="ltn__top-bar-menu">
                  <ul>
                    <li>
                      <a href="mailto:contact@medesco.ma?Subject=Flower%20greetings%20to%20you">
                        <i className="icon-mail" /> contact@medesco.ma
                      </a>
                    </li>
                    <li>
                      <a href="locations.html">
                        <i className="icon-placeholder" /> Sidi Idriss Tanger,
                        Maroc{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-5">
                <div className="top-bar-right text-end">
                  <div className="ltn__top-bar-menu">
                    <ul>
                      <li className="d-none"></li>
                      <li>
                        <Social />
                      </li>
                      <li>{/* header-top-btn */}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ltn__header-middle-area start */}
        <div className="ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-black">
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="site-logo-wrap">
                  <div className="site-logo go-top">
                    <Link to="/">
                      <img
                        src={publicUrl + "assets/img/logo.svg"}
                        width="70%"
                        alt="Logo"
                      />
                    </Link>
                  </div>
                  <div className="get-support clearfix d-none"></div>
                </div>
              </div>
              <div style={{placeItems: "end"}} className="col header-menu-column menu-color-white">
                <div className="header-menu d-none d-xl-block go-top">
                  <nav>
                    <div className="ltn__main-menu">
                      <ul>
                        {allLinks.map((item, idx) => (
                          <li key={idx}>
                            <a href={item.href}>{item.label}</a>
                          </li>
                        ))}
                        {/* <li>
                          <button
                            className="btn fw-medium px-4 py-2 rounded"
                            style={{ alignItems: "center",
                              backgroundColor: "#204077",
                              color: "white",
                              border: "none",
                              whiteSpace: "nowrap", // This is the key!
                            }}
                          >
                            réservez dès maintenant
                          </button>
                        </li> */}
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
              <div className="col--- ltn__header-options ltn__header-options-2 ">
                {/* Mobile Menu Button */}
                <div className="mobile-menu-toggle d-xl-none">
                  <a
                    href="#ltn__utilize-mobile-menu"
                    className="ltn__utilize-toggle"
                  >
                    <svg viewBox="0 0 800 600">
                      <path
                        d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"
                        id="top"
                      />
                      <path d="M300,320 L540,320" id="middle" />
                      <path
                        d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190"
                        id="bottom"
                        transform="translate(480, 320) scale(1, -1) translate(-480, -318) "
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ltn__header-middle-area end */}
      </header>

      {/* Menu Mobile */}
      <div
        id="ltn__utilize-mobile-menu"
        className="ltn__utilize ltn__utilize-mobile-menu"
      >
        <div className="ltn__utilize-menu-inner ltn__scrollbar">
          <div className="ltn__utilize-menu-head">
            <div className="site-logo">
              <Link to="/">
                <img src={publicUrl + "assets/img/logo.png"} alt="Logo" />
              </Link>
            </div>
            <button className="ltn__utilize-close">×</button>
          </div>
          
          <div className="ltn__utilize-menu">
            <ul>
              {allLinks.map((item, idx) => (
                <li key={idx}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="ltn__social-media-2">
            <Social />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarV3;
